import React from 'react';
import LockLockedIcon from '@atlaskit/icon/core/migration/lock-locked--lock-filled';
import { Inline, Stack, Text } from '@atlaskit/primitives';
import { components, type OptionProps } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { SecurityOption } from '../types.tsx';
import type { SelectOptionStandaloneProps } from './types.tsx';

export const SelectOption = (props: OptionProps<SecurityOption>) => {
	const { label, description } = props.data;
	return (
		<components.Option {...props}>
			<SelectOptionStandalone label={label} description={description} />
		</components.Option>
	);
};

export const SelectOptionStandalone = ({ label, description }: SelectOptionStandaloneProps) => (
	<Inline alignBlock="center" space="space.150">
		<LockLockedIcon color={token('color.icon.danger')} label="" />
		<Stack>
			<Inline alignBlock="center" space="space.050">
				{label}
			</Inline>
			<Text color="color.text.subtlest">{description}</Text>
		</Stack>
	</Inline>
);
